import { Component, inject, Input, signal } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { TestIdDirective } from '@bayclubs/horizon';
import { UtilsModule } from '@bayclubs/utils';
import { TranslateDirective } from '@ngx-translate/core';
import { campsenum } from '../../../../models/enums.generated';
import { camps } from '../../../../models/models.generated';
import RefundReason = campsenum.RefundReason;

@Component({
    selector: 'app-purchase-edit-refund-reason-modal',
    templateUrl: './purchase-edit-refund-reason-modal.component.html',
    imports: [
        TranslateDirective,
        ReactiveFormsModule,
        UtilsModule,
        TestIdDirective
    ]
})
export class PurchaseEditRefundReasonModalComponent {
    @Input() purchase: camps.OfficeCartPurchaseInfo;

    close: Function;
    value: { reason: RefundReason, comment: string };

    refundReasons = signal<{
        displayKey: string;
        value: string;
    }[]>([
        { displayKey: 'Complimentary', value: RefundReason[RefundReason.Complimentary] },
        { displayKey: 'Customer changed mind', value: RefundReason[RefundReason.CustomerChangedMind] },
        { displayKey: 'Employee error', value: RefundReason[RefundReason.EmployeeError] },
        { displayKey: 'Training', value: RefundReason[RefundReason.Training] },
        { displayKey: 'Other', value: RefundReason[RefundReason.Other] }
    ]);

    private fb = inject(FormBuilder);

    refundForm = this.fb.group({
        reason: this.fb.control(null, [ Validators.required ]),
        comment: this.fb.control('', [ Validators.required ])
    });

    confirm() {
        this.value = this.refundForm.getRawValue();
        this.close();
    }
}
